"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a CHANGE_AUTHORISATION_ROLES_FILTER request.
 */
var ChangeAuthorisationRolesFilterRequest = /** @class */ (function () {
    /**
     * Create a new ChangeAuthorisationRolesFilterRequest instance
     *
     * @param sessionID         the filter specifying the sessions on which the roles should be changed
     * @param rolesToRemove     the roles to remove
     * @param removeProperties  the roles to add
     */
    function ChangeAuthorisationRolesFilterRequest(filter, rolesToRemove, rolesToAdd) {
        this.filter = filter;
        this.rolesToRemove = rolesToRemove;
        this.rolesToAdd = rolesToAdd;
    }
    return ChangeAuthorisationRolesFilterRequest;
}());
exports.ChangeAuthorisationRolesFilterRequest = ChangeAuthorisationRolesFilterRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/change-authorisation-roles-filter-request.js
// module id = 1185
// module chunks = 1